import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=f4f1a16c&scoped=true"
import script from "./CustomerSearch.vue?vue&type=script&lang=js"
export * from "./CustomerSearch.vue?vue&type=script&lang=js"
import style0 from "./CustomerSearch.vue?vue&type=style&index=0&id=f4f1a16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f1a16c",
  null
  
)

export default component.exports